import * as React from 'react'

import ComputerCharts from 'assets/images/computer-charts-magnifying-glass.svg'

import i18n from 'modules/core/lib/i18n'

import IllustratedBlankSlate from 'modules/reviews/components/Analytics/BlankSlate/IllustratedBlankSlate'

const BlankSlate = () => (
  <IllustratedBlankSlate
    illustration={ComputerCharts}
    description={i18n.t('competencies_v2.employees.empty_assessment')}
  />
)

export default BlankSlate
